import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { AuthShell } from "@/pages/auth/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true); setError("");
        try {
            await api.post("/auth/reset-password", { token, password });
            navigate("/login");
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        } finally { setBusy(false); }
    };

    return (
        <AuthShell title="Set New Password" subtitle="Choose a new password for your account.">
            <form onSubmit={submit} className="space-y-4">
                {error && <div data-testid="reset-error" className="rounded-md border border-danger/40 bg-danger/10 px-3 py-2 text-sm text-danger">{error}</div>}
                {!token && <div className="text-sm text-warning">Missing reset token. Use the link from your email.</div>}
                <div>
                    <label className="label-mono text-muted-foreground">New Password</label>
                    <Input data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
                        className="mt-1 bg-background border-border" placeholder="••••••••" />
                </div>
                <Button data-testid="reset-submit" type="submit" disabled={busy || !token}
                    className="w-full font-heading uppercase tracking-wide bg-hazard text-black hover:bg-hazard/90">
                    {busy ? <Loader2 className="animate-spin" size={16} /> : "Reset Password"}
                </Button>
                <Link to="/login" className="block text-center text-sm text-muted-foreground hover:text-hazard">Back to sign in</Link>
            </form>
        </AuthShell>
    );
}
